const content = [{
    id: 'Kitten Box',
    src: 'content/kitten-label.png',
    imgStyle: {
        padding: '20px',
        transform: 'scale(0.5)',
        transformOrigin: 'top left'
    },
     
    background: "transparent",
    fg_color: "#cf5f4d",
    // alpha: 0.7,

    // rows: 1,
    // columns: 1,

    width: 6400,
    height: 4800,

    x: 4000,
    y: -4800
},
{
    id: 'Puppy Box',
    src: 'content/puppy-label.png',
    imgStyle: {
        padding: '20px',
        transform: 'scale(0.5)',
        transformOrigin: 'top left'
    },

    background: "transparent",
    fg_color: "#e0b54e",
    // alpha: 0.7,

    // rows: 1,
    // columns: 1,

    width: 6400,
    height: 4800,

    x: 4000+6400,
    y: -4800
},
{
    id: 'Other Box',
    src: 'content/other-label.png',
    imgStyle: {
        padding: '20px',
        transform: 'scale(0.5)',
        transformOrigin: 'top left'
    },

    background: "transparent",
    fg_color: "#58b9ad",
    // alpha: 0.7,

    // rows: 1,
    // columns: 1,

    width: 6400,
    height: 4800,

    x: 4000+6400+6400,
    y: -4800
},
{
    id: 'BW Box',
    src: 'content/bw-label.png',
    imgStyle: {
        padding: '20px',
        transform: 'scale(0.5)',
        transformOrigin: 'top left'
    },

    background: "transparent",
    fg_color: "#77b3de",
    // alpha: 0.7,

    // rows: 1,
    // columns: 1,

    width: 800,
    height: 1200,

    x: 4000,
    y: 8000
}];

export default [];